import { render } from "./VipPage.vue?vue&type=template&id=357a6f18&scoped=true"
import script from "./VipPage.vue?vue&type=script&lang=js"
export * from "./VipPage.vue?vue&type=script&lang=js"

import "./VipPage.vue?vue&type=style&index=0&id=357a6f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357a6f18"]])

export default __exports__